import Block from '@/components/Block'
import { GsuHTMLEmbed } from '@/compositions/GsuHTMLEmbed'
import PageLayout from '@/compositions/PageLayout'
import { getConfig } from '@/lib/config'
import { GetServerSideProps, NextPage } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Head from 'next/head'

const { publicRuntimeConfig } = getConfig()

const ArticlesDiscoverPage: NextPage = () => {
  const { partnerId, page } = publicRuntimeConfig?.gsuHTMLEmbeds.articles
  return (
    <PageLayout>
      <Head>
        <title>Articles</title>
      </Head>
      <Block theme="white">
        <GsuHTMLEmbed partnerId={partnerId} page={page} />
      </Block>
    </PageLayout>
  )
}

export const getServerSideProps: GetServerSideProps = async ({ locale = 'en-US' }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'classes'])),
      disableAuthPrompt: true,
    },
  }
}

export default ArticlesDiscoverPage
